<!-- MainComponent.vue -->
<template>
  <div class="savePannel">
   <div class="header">
    <h2>Create Preset</h2>
    <span @click="closePannel" class="mar-r-1 material-symbols-rounded"> &#xe5cd; </span>
   </div>

   <div class="intro">
    <svg width="140" height="139" viewBox="0 0 140 139" fill="none" xmlns="http://www.w3.org/2000/svg">
     <rect x="0.5" width="139" height="139" rx="69.5" fill="#161728" fill-opacity="0.6" />
     <path
       d="M35.3645 74.4479C34.0451 74.4479 32.8906 73.9531 31.901 72.9635C30.9114 71.9739 30.4166 70.8194 30.4166 69.5C30.4166 68.1805 30.9114 67.026 31.901 66.0364C32.8906 65.0468 34.0451 64.552 35.3645 64.552C36.684 64.552 37.8385 65.0468 38.8281 66.0364C39.8177 67.026 40.3125 68.1805 40.3125 69.5C40.3125 70.8194 39.8177 71.9739 38.8281 72.9635C37.8385 73.9531 36.684 74.4479 35.3645 74.4479ZM40.5104 94.6354L53.375 81.7708C53.9687 81.177 54.6614 80.8967 55.4531 80.9296C56.2447 80.9626 56.9375 81.276 57.5312 81.8697C58.125 82.4635 58.4218 83.1727 58.4218 83.9974C58.4218 84.822 58.125 85.5312 57.5312 86.125L44.6666 98.9895C44.0729 99.5833 43.3802 99.8637 42.5885 99.8307C41.7968 99.7977 41.1041 99.4843 40.5104 98.8906C39.9166 98.2968 39.6198 97.5876 39.6198 96.763C39.6198 95.9383 39.9166 95.2291 40.5104 94.6354ZM53.375 56.9322L40.5104 44.1666C39.9166 43.5729 39.6362 42.8802 39.6692 42.0885C39.7022 41.2968 40.0156 40.6041 40.6093 40.0104C41.2031 39.4166 41.9123 39.1198 42.7369 39.1198C43.5616 39.1198 44.2708 39.4166 44.8645 40.0104L57.6302 52.776C58.2239 53.3697 58.5208 54.0625 58.5208 54.8541C58.5208 55.6458 58.2239 56.3385 57.6302 56.9322C57.0364 57.526 56.3272 57.8229 55.5026 57.8229C54.6779 57.8229 53.9687 57.526 53.375 56.9322ZM70 109.083C68.6805 109.083 67.526 108.589 66.5364 107.599C65.5468 106.609 65.052 105.455 65.052 104.135C65.052 102.816 65.5468 101.661 66.5364 100.672C67.526 99.6822 68.6805 99.1875 70 99.1875C71.3194 99.1875 72.4739 99.6822 73.4635 100.672C74.4531 101.661 74.9479 102.816 74.9479 104.135C74.9479 105.455 74.4531 106.609 73.4635 107.599C72.4739 108.589 71.3194 109.083 70 109.083ZM70 39.8125C68.6805 39.8125 67.526 39.3177 66.5364 38.3281C65.5468 37.3385 65.052 36.184 65.052 34.8645C65.052 33.5451 65.5468 32.3906 66.5364 31.401C67.526 30.4114 68.6805 29.9166 70 29.9166C71.3194 29.9166 72.4739 30.4114 73.4635 31.401C74.4531 32.3906 74.9479 33.5451 74.9479 34.8645C74.9479 36.184 74.4531 37.3385 73.4635 38.3281C72.4739 39.3177 71.3194 39.8125 70 39.8125ZM82.4687 52.677L95.2343 39.9114C95.8281 39.3177 96.5208 39.0373 97.3125 39.0703C98.1041 39.1033 98.7968 39.4166 99.3906 40.0104C99.9843 40.6041 100.281 41.3133 100.281 42.138C100.281 42.9626 99.9843 43.6718 99.3906 44.2656L86.625 57.0312C86.0312 57.625 85.3385 57.9053 84.5468 57.8724C83.7552 57.8394 83.0625 57.526 82.4687 56.9322C81.875 56.3385 81.5781 55.6293 81.5781 54.8046C81.5781 53.98 81.875 53.2708 82.4687 52.677ZM95.2343 98.7916L82.3697 86.026C81.776 85.4322 81.4956 84.7395 81.5286 83.9479C81.5616 83.1562 81.875 82.4635 82.4687 81.8697C83.0625 81.276 83.7717 80.9791 84.5963 80.9791C85.421 80.9791 86.1302 81.276 86.7239 81.8697L99.4895 94.6354C100.083 95.2291 100.38 95.9218 100.38 96.7135C100.38 97.5052 100.083 98.1979 99.4895 98.7916C98.8958 99.3854 98.1866 99.6823 97.3619 99.6823C96.5373 99.6823 95.8281 99.3854 95.2343 98.7916ZM104.635 74.4479C103.316 74.4479 102.161 73.9531 101.172 72.9635C100.182 71.9739 99.6875 70.8194 99.6875 69.5C99.6875 68.1805 100.182 67.026 101.172 66.0364C102.161 65.0468 103.316 64.552 104.635 64.552C105.955 64.552 107.109 65.0468 108.099 66.0364C109.089 67.026 109.583 68.1805 109.583 69.5C109.583 70.8194 109.089 71.9739 108.099 72.9635C107.109 73.9531 105.955 74.4479 104.635 74.4479Z"
       fill="white" />
     <path
       d="M69.8978 85.7C69.6338 85.7 69.3698 85.652 69.1059 85.556C68.8419 85.46 68.614 85.3161 68.422 85.1241L66.5143 83.3604C63.5387 80.6008 60.9591 77.9672 58.7755 75.4596C56.5918 72.952 55.5 70.3304 55.5 67.5948C55.5 65.4352 56.2259 63.6294 57.6777 62.1777C59.1294 60.7259 60.9232 60 63.0588 60C64.2826 60 65.4944 60.294 66.6943 60.8819C67.8941 61.4698 68.9619 62.4356 69.8978 63.7794C70.9536 62.4356 72.0454 61.4698 73.1732 60.8819C74.3011 60.294 75.4889 60 76.7367 60C78.8724 60 80.6661 60.7259 82.1179 62.1777C83.5696 63.6294 84.2955 65.4352 84.2955 67.5948C84.2955 70.3304 83.2037 72.952 81.02 75.4596C78.8364 77.9672 76.2568 80.6008 73.2812 83.3604L71.3735 85.1241C71.1816 85.3161 70.9536 85.46 70.6896 85.556C70.4257 85.652 70.1617 85.7 69.8978 85.7Z"
       fill="#EC6A5E" />
    </svg>

    <!-- <p>Save your unique soundscape and make it public for others to enjoy</p> -->
    <p>Save your unique soundscape</p>
   </div>

   <form class="form" @submit.prevent="saveSettings">
    <div class="input-group">
      <input type="text" name="mixName" v-model="name" placeholder="Enter a name for this mix">
      <input type="text" name="mixName" v-model="description" placeholder="Enter a description of the mix">
       <!-- <div class="checkbox-group">
        <input type="checkbox" name="mixName" id="mixName" v-model="makePublic">
        <label for="mixName">Make Public for everyone to enjoy</label>
       </div> -->
    </div>
    <button :disabled="!name || !description" name="button">Save Mix</button>

   </form>

  </div>

</template>

<script>
import {
 projectAuth,
 projectFirestore
} from '../main'

export default {
  props: {

  },
  data() {
    return {
      name: '',
      description: '',
      makePublic: false,
    };
  },
  mounted: function(){
  },
  methods: {

    closePannel() {
     this.$root.saveMix = false;
     this.name = null;
     this.makePublic = false;
    },
    saveSettings() {
     // Wait for the next rendering cycle to ensure child components are ready
     this.$nextTick(() => {
      const settings = {};
      for (const key in this.$root.$refs.customSoundMixer.$refs) {
       const component = this.$root.$refs.customSoundMixer.$refs[key];

       if (component && component.name) {
        settings[component.name] = {
         playing: component.isPlaying,
         volume: component.volume,
        };
       }
      }

      projectAuth.onAuthStateChanged((user) => {
       const uid = user.uid

       const mixData = {
        name: this.name,
        description: this.description,
        created: new Date(),
        createdBy: uid,
        approve: false,
        mix: settings,
        displayName: user.uid
       }
       const mixDataPublic = {
        name: this.name,
        description: this.description,
        created: new Date(),
        createdBy: uid,
        public: true,
        approve: false,
        mix: settings,
        displayName: user.uid
       }

       projectFirestore.collection("users").doc(uid).collection("personal-mixes").doc().set(mixData).then(() => {
        if (this.makePublic === true) {
         projectFirestore.collection("public-mixes").doc().set(mixDataPublic)
        }
        // Show the save confirmation message
        this.$root.saveMix = false;
        this.$root.showSaveMessage = true;
        setTimeout(() => {
         this.$root.showSaveMessage = false;
        }, 6000);
       });
      })

     });
    },
    saveBrandNix() {
     // Wait for the next rendering cycle to ensure child components are ready
     this.$nextTick(() => {
      const settings = {};
      for (const key in this.$root.$refs.customSoundMixer.$refs) {
       const component = this.$root.$refs.customSoundMixer.$refs[key];

       if (component && component.name) {
        settings[component.name] = {
         playing: component.isPlaying,
         volume: component.volume,
        };
       }
      }

      projectAuth.onAuthStateChanged((user) => {
       const uid = user.uid

       const mixData = {
        name: this.name,
        description: this.description,
        created: new Date(),
        createdBy: uid,
        public: this.makePublic,
        approve: false,
        mix: settings,
        displayName: user.uid
       }

       projectFirestore.collection("brand-mixes").doc().set(mixData).then(() => {
        // Show the save confirmation message
        this.$root.saveMix = false;
        this.$root.showSaveMessage = true;
        setTimeout(() => {
         this.$root.showSaveMessage = false;
        }, 6000);
       });
      })

     });
    },


  },
};
</script>
